import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalState<T> {
  isOpen: boolean;
  config?: T;
}

export class BaseModalService<T = void> {
  private readonly modalStateSubject = new BehaviorSubject<ModalState<T> | null>(null);
  modalState$: Observable<ModalState<T> | null> = this.modalStateSubject.asObservable();

  open(data?: T) {
    this.modalStateSubject.next({ isOpen: true, config: data });
  }

  close() {
    this.modalStateSubject.next({ isOpen: false });
  }
}